








































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryDepositModel } from '@/models/summary-deposit';
@Component
export default class SummaryOrder extends Vue {
    @Prop({default: null})
    private chinaAddress!: any;
    @Prop({default: null})
    private summaryOrder!: SummaryDepositModel;

    @Prop({default: null})
    private selectedStatus!: any;

    private isCollapse: boolean = true;

    private async onCollapse() {
        this.isCollapse = !this.isCollapse;
    }
}
